import React from "react";
import "./Preprints.scss";

// 1. Import your images here
import chorusLogo from "./chorus_logo.png";
import crossRefLogo from "./Powered_by_CrossRef.png";
import porticoLogo from "./porticoLogo.png";
import clockssLogo from "./clockssLogo.png";
import orcidLogo from "./orcidLogo.png";
import scholixLogo from "./scholix.jpg";
import dataCiteLogo from "./DataCite_logo.png";
import getFtrLogo from "./GetFTR_Logo_Full.png";
import logoFooter from "./logo-footer.png";

const Preprints = () => {
  return (
    // min-vh-100 and d-flex flex-column stretch the container so the footer sticks to the bottom
    <div
      className="d-flex flex-column min-vh-100 bg-white"
      style={{
        fontFamily:
          '"Open Sans", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      }}
    >
      {/* Header */}
      <header className="pb-5 pt-0">
        <div className="container">
          <div className="d-flex align-items-baseline gap-3">
            <h1 className="fw-light m-0" style={{ letterSpacing: "2px" }}>
              <a
                href="http://www.chorusaccess.org/"
                className="text-secondary text-decoration-none"
              >
                <img
                  src={chorusLogo}
                  alt="CHORUS"
                  className="header-logo-img"
                />
              </a>
            </h1>
            <span className="fs-5 text-secondary fst-italic">
              Advancing Open Access to Research
            </span>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container flex-grow-1 py-5">
        <p className="fs-5 text-secondary mb-4">Currently available for:</p>
        <ul className="ps-4">
          <li className="mb-2 fs-5">
            <a
              href="https://preprint.chorusaccess.org/chemrxiv"
              className="text-chorus-link text-decoration-none"
            >
              ChemRxiv Dashboard
            </a>
          </li>
          <li className="mb-2 fs-5">
            <a
              href="https://preprint.chorusaccess.org/techrxiv"
              className="text-chorus-link text-decoration-none"
            >
              TechRxiv Dashboard
            </a>
          </li>
          <li className="mb-2 fs-5">
            <a
              href="https://preprint.chorusaccess.org/opticaopen"
              className="text-chorus-link text-decoration-none"
            >
              Optica Open Dashboard
            </a>
          </li>
        </ul>
      </main>

      {/* Footer Logos Section */}
      <div className="container pt-5 pb-4 d-flex flex-column align-items-center">
        <div>
          {" "}
          <a
            href="http://www.chorusaccess.org/contact-us"
            target="_blank"
            rel="noreferrer"
            className="d-block mb-4 text-chorus-link text-decoration-none"
          >
            Leave feedback
          </a>
          <div className="d-flex flex-wrap align-items-center gap-4">
            <a
              href="http://search.crossref.org/fundref"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={crossRefLogo}
                alt="Crossref"
                className="partner-logo-img"
              />
            </a>
            <a href="http://www.portico.org/" target="_blank" rel="noreferrer">
              <img
                src={porticoLogo}
                alt="Portico"
                className="partner-logo-img"
              />
            </a>
            <a href="http://www.clockss.org/" target="_blank" rel="noreferrer">
              <img
                src={clockssLogo}
                alt="CLOCKSS"
                className="partner-logo-img"
              />
            </a>
            <a href="http://www.orcid.org/" target="_blank" rel="noreferrer">
              <img src={orcidLogo} alt="ORCID" className="partner-logo-img" />
            </a>
            <a
              href="http://scholexplorer.openaire.eu/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={scholixLogo}
                alt="ScholeXplorer"
                className="partner-logo-img"
              />
            </a>
            <a href="https://datacite.org/" target="_blank" rel="noreferrer">
              <img
                src={dataCiteLogo}
                alt="DataCite"
                className="partner-logo-img"
              />
            </a>
            <a href="#" target="_blank" rel="noreferrer">
              <img
                src={getFtrLogo}
                alt="Get FullText Research"
                className="partner-logo-img"
              />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Site Footer */}
      <footer
        className="bg-light border-top py-3 text-secondary"
        style={{ fontSize: "12px" }}
      >
        <div className="container d-flex justify-content-between align-items-center flex-wrap">
          <div className="d-flex align-items-center">
            <img
              src={logoFooter}
              alt="Logo Footer"
              className="ms-4 me-2 my-2"
              style={{ height: "20px" }}
            />
            <span>
              &copy; {new Date().getFullYear()} CHOR, Inc. |{" "}
              <a
                href="http://www.chorusaccess.org/terms-of-use/"
                target="_blank"
                rel="noreferrer"
                className="footer-link"
              >
                Terms of Use
              </a>{" "}
              |{" "}
              <a
                href="http://www.chorusaccess.org/privacy-policy/"
                target="_blank"
                rel="noreferrer"
                className="footer-link"
              >
                Privacy Policy
              </a>{" "}
              |{" "}
              <a
                href="http://www.windmilldesign.com/portfolio/web-design-and-development-for-chorus"
                target="_blank"
                rel="noreferrer"
                className="footer-link"
              >
                Site Credits
              </a>
            </span>
          </div>

          <nav>
            <ul className="list-unstyled d-flex gap-3 m-0 p-0">
              <li>
                <a
                  href="http://chorusaccess.org/about/"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-link"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="http://chorusaccess.org/services/"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-link"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="http://chorusaccess.org/newsroom/"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-link"
                >
                  News
                </a>
              </li>
              <li>
                <a
                  href="http://chorusaccess.org/events/"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-link"
                >
                  Events
                </a>
              </li>
              <li>
                <a
                  href="http://chorusaccess.org/resources/"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-link"
                >
                  Resources
                </a>
              </li>
              <li>
                <a
                  href="http://chorusaccess.org/contact/"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-link"
                >
                  Contact
                </a>
              </li>
              <li>
                <a
                  href="http://chorusaccess.org/join/"
                  target="_blank"
                  rel="noreferrer"
                  className="join-link text-decoration-none"
                >
                  JOIN
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </footer>
    </div>
  );
};

export default Preprints;

// import React from "react";
// import "./Preprints.scss";

// // 1. Import your images here
// import chorusLogo from "./chorus_logo.png";
// import crossRefLogo from "./Powered_by_CrossRef.png";
// import porticoLogo from "./porticoLogo.png";
// import clockssLogo from "./clockssLogo.png";
// import orcidLogo from "./orcidLogo.png";
// import scholixLogo from "./scholix.jpg";
// import dataCiteLogo from "./DataCite_logo.png";
// import getFtrLogo from "./GetFTR_Logo_Full.png";
// import logoFooter from "./logo-footer.png";

// const Preprints = () => {
//   return (
//     <div className="preprints-container">
//       {/* Header matching the screenshot */}
//       <header className="site-header">
//         <div className="container">
//           <div className="header-brand">
//             <h1 className="logo">
//               <a href="http://www.chorusaccess.org/">
//                 {" "}
//                 <img src={chorusLogo} alt="CHORUS" />
//               </a>
//             </h1>
//             <span className="tagline">Advancing Open Access to Research</span>
//           </div>
//         </div>
//       </header>

//       {/* Main Content */}
//       <main className="container content-section">
//         <p className="lead-text">Currently available for:</p>
//         <ul className="dashboard-list">
//           <li>
//             <a href="https://preprint.chorusaccess.org/chemrxiv">
//               ChemRxiv Dashboard
//             </a>
//           </li>
//           <li>
//             <a href="https://preprint.chorusaccess.org/techrxiv">
//               TechRxiv Dashboard
//             </a>
//           </li>
//           <li>
//             <a href="https://preprint.chorusaccess.org/opticaopen">
//               Optica Open Dashboard
//             </a>
//           </li>
//         </ul>
//       </main>

//       {/* Footer Logos Section */}
//       <div className="container footer-logos-section">
//         <a
//           href="http://www.chorusaccess.org/contact-us"
//           target="_blank"
//           rel="noreferrer"
//           className="feedback-link"
//         >
//           Leave feedback
//         </a>
//         <div className="logos-row">
//           <a
//             href="http://search.crossref.org/fundref"
//             target="_blank"
//             rel="noreferrer"
//           >
//             <img src={crossRefLogo} alt="Crossref" />
//           </a>
//           <a href="http://www.portico.org/" target="_blank" rel="noreferrer">
//             <img src={porticoLogo} alt="Portico" />
//           </a>
//           <a href="http://www.clockss.org/" target="_blank" rel="noreferrer">
//             <img src={clockssLogo} alt="CLOCKSS" />
//           </a>
//           <a href="http://www.orcid.org/" target="_blank" rel="noreferrer">
//             <img src={orcidLogo} alt="ORCID" />
//           </a>
//           <a
//             href="http://scholexplorer.openaire.eu/"
//             target="_blank"
//             rel="noreferrer"
//           >
//             <img src={scholixLogo} alt="ScholeXplorer" />
//           </a>
//           <a href="https://datacite.org/" target="_blank" rel="noreferrer">
//             <img src={dataCiteLogo} alt="DataCite" />
//           </a>
//           <a href="#" target="_blank" rel="noreferrer">
//             <img src={getFtrLogo} alt="Get FullText Research" />
//           </a>
//         </div>
//       </div>

//       {/* Bottom Site Footer */}
//       <footer className="site-footer">
//         <div className="container footer-layout">
//           <div className="site-footer-info">
//             <div className="copyright">
//               <img
//                 src={logoFooter}
//                 alt="Logo Footer"
//                 className="ms-4 me-2 my-5"
//               />
//               &copy;
//               <span className="copyright-year">
//                 {new Date().getFullYear()} CHOR, Inc.
//               </span>{" "}
//               |{" "}
//               <a
//                 href="http://www.chorusaccess.org/terms-of-use/"
//                 target="_blank"
//                 rel="noreferrer"
//               >
//                 Terms of Use
//               </a>{" "}
//               |{" "}
//               <a
//                 href="http://www.chorusaccess.org/privacy-policy/"
//                 target="_blank"
//                 rel="noreferrer"
//               >
//                 Privacy Policy
//               </a>{" "}
//               |{" "}
//               <a
//                 href="http://www.windmilldesign.com/portfolio/web-design-and-development-for-chorus"
//                 target="_blank"
//                 rel="noreferrer"
//               >
//                 Site Credits
//               </a>
//             </div>
//           </div>
//           <nav className="nav-footer">
//             <ul>
//               <li>
//                 <a
//                   href="http://chorusaccess.org/about/"
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   About
//                 </a>
//               </li>
//               <li>
//                 <a
//                   href="http://chorusaccess.org/services/"
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   Services
//                 </a>
//               </li>
//               <li>
//                 <a
//                   href="http://chorusaccess.org/newsroom/"
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   News
//                 </a>
//               </li>
//               <li>
//                 <a
//                   href="http://chorusaccess.org/events/"
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   Events
//                 </a>
//               </li>
//               <li>
//                 <a
//                   href="http://chorusaccess.org/resources/"
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   Resources
//                 </a>
//               </li>
//               <li>
//                 <a
//                   href="http://chorusaccess.org/contact/"
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   Contact
//                 </a>
//               </li>
//               <li className="join">
//                 <a
//                   href="http://chorusaccess.org/join/"
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   JOIN
//                 </a>
//               </li>
//             </ul>
//           </nav>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default Preprints;
